import * as Yup from 'yup';
import DomPurify from 'dompurify';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';
import { TemplateFormDropdownFieldMetaProps } from '../interfaces/template-form-dropdown-field-meta';
import { TemplateFormHelperText } from '../../TemplateFormHelperText';
import { TemplateFormFieldValidationsFactory } from '../../../factories/templateFormFieldValidationFactory';
import { TemplateFormDropdownField } from '../TemplateFormDropdownField';

export interface OptionsObject {
  label: string;
  value: string;
}

export const TemplateFormDropdownFieldMeta: TemplateFormComponentMeta<
  TemplateFormDropdownFieldMetaProps,
  {
    is_free_solo?: boolean;
    is_multiple?: boolean;
    disable_clearable?: boolean;
    placeholder?: string;
    options?: OptionsObject[] | string[];
  }
> = {
  component: TemplateFormDropdownField,
  MetadataFactory: (field, disableEdit) => ({
    dataId: `template-form-${field.name}`,
    fieldName: field.name,
    options: (field.component?.options || []).map(option =>
      typeof option === 'object' ? { label: option.label, value: option.value } : option
    ),
    disabled: disableEdit || !!field.disabled,
    textFieldProps: {
      required: !!field.required,
      label: DomPurify.sanitize(field.display_name ?? ''),
      placeholder: field.component?.placeholder,
      helperText: TemplateFormHelperText({ helperText: field.helper_text, fieldName: field.name })
    },
    disableClearable: !!field.component?.disable_clearable,
    value: (field?.default_value as OptionsObject | string | OptionsObject[] | string[]) || '',
    freeSolo: !!field.component?.is_free_solo,
    multiple: !!field.component?.is_multiple
  }),
  ValidationSchemaFactory: field => {
    const schema = field.component?.is_multiple
      ? Yup.array().of(Yup.string())
      : Yup.string().nullable();
    return TemplateFormFieldValidationsFactory(field, schema);
  }
};
